import type { ApiError } from '../api/client';
import { Button } from '../ui/Button';

/**
 * A failed read rendered in place (spec section 3.2): a transport failure, a 403, a 404 or a 5xx never redirect to
 * sign-in; the message, the request id and a Retry stay on the page.
 */
export function ErrorPage({ error, retry, title }: { error: ApiError; retry?: () => void; title?: string }) {
  const heading = title ?? (error.status === 404 ? 'Not found' : error.status === 403 ? 'No permission' : error.status === 0 ? 'The API is unreachable' : 'Something went wrong');
  return (
    <section className="card" role="alert" style={{ maxWidth: 560, margin: '48px auto' }}>
      <h2 style={{ marginTop: 0 }}>{heading}</h2>
      <p>{error.message}</p>
      {error.requestId && (
        <p className="muted small">
          request <code>{error.requestId}</code>
          {error.status ? ` · HTTP ${error.status} · ${error.code}` : ''}
        </p>
      )}
      {retry && (
        <Button variant="primary" onClick={retry}>
          Retry
        </Button>
      )}
    </section>
  );
}

export function NotFoundPage() {
  return (
    <section className="card" style={{ maxWidth: 560, margin: '48px auto' }}>
      <h2 style={{ marginTop: 0 }}>Page not found</h2>
      <p className="muted">The address does not match a page of the dashboard. Use the sidebar or the command palette (Ctrl+K).</p>
    </section>
  );
}
